"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResolvedValueNodeBinding = getResolvedValueNodeBinding;
function getResolvedValueNodeBinding(node) {
    return node.binding;
}
//# sourceMappingURL=getResolvedValueNodeBinding.js.map